var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:['login', { login2: !_vm.show }]},[(_vm.isAiChdesign)?_c('LeftService'):_vm._e(),_c('div',{staticClass:"right"},[(!_vm.show)?_c('LeftService2'):_vm._e(),_c('NewRightLogin',{attrs:{"show":_vm.show}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }